import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@novel-isr/ui/styles.css";
import { App } from "./App.tsx";
import "./styles/global.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
